import { createContext } from 'react';

export const ConnectFormContext = createContext({
  referrer: '',
  trialPeriod: '',
  isConnecting: false,
  connect: (_connectData = {}) => false,
  isError: false,
  errorMessage: ''
});
